import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html'
})
export class AboutUsComponent implements OnInit {

  titleSectionProp: any = {
    class: 'text-center',
    title: 'INFORMACIÓN ADICIONAL',
    subTitle: 'Nuestras Políticas'
  };
  
  List: any[] = [
    {
      title: 'Seguridad de la información',
      subtitle: 'Información almacenada en la plataforma es confidencial y no se comparte con ninguna otra entidad.',
      image: './assets/images/scholae/shield.png'
    },
    {
      title: 'Actualizaciones gratuitas',
      subtitle: 'Scholae es una plataforma que se provee como servicio, por lo tanto, las actualizaciones y mejoras realizadas sobre los módulos ya contratados no tienen costo adicional.',
      image: './assets/images/scholae/refresh.png'
    },
    {
      title: 'Implementación',
      subtitle: 'El tiempo de implementación tiene una duración aproximada de 15 días.',
      image: './assets/images/scholae/plan.png'
    }
  ];

  constructor() { }

  ngOnInit() {
  }

}
